/**
 * Created by slava on 02.02.17.
 */

const HeroCellView = GoalColorCellView.extend({
    ctor: function (cell) {
        this._super(cell);

        const color = cell.findComponent(ColorComponent).color.toUpperCase();
        this.animation = new cleverapps.Spine(cleverapps.skins.getSlot(`${color}_hero_spine_json`) || bundles.heroes.jsons[`${color}_hero_spine_json`]);
        this.animation.setSkin(match3.heroes.getCurrentSkin());
        this.animation.setPosition(this.width / 2, this.height / 2);
        this.animation.setAnimation(0, "idle", true);
        this.addChild(this.animation, -1);
    },

    createAnimation: function (params) {
        cleverapps.effects.fire("match3.booster5.show");

        params = params || {};
        if (!params.silent) {
            this.setScale(0);
            this.runAction(new cc.ScaleTo(0.4, 1).easing(cc.easeBackOut()));
        }

        const light = this.light = new cleverapps.Spine(bundles.game.jsons.story_light_animation_json);
        light.setScale(2);
        light.setAlignment(this.width / 2 + cleverapps.styles.FireworkCellView.light.x, this.height / 2 + cleverapps.styles.FireworkCellView.light.y);
        light.setLocalZOrder(-2);
        this.addChild(light);

        let lightZOrder = this.getLocalZOrder();
        if (!lightZOrder) {
            lightZOrder = 0;
        }
        this.setLocalZOrder(3);
        light.setAnimation(0, "animation", true);
        light.runAction(new cc.Sequence(
            new cc.DelayTime(1.5),
            new cc.ScaleTo(0.2, 0),
            new cc.CallFunc(() => {
                this.setLocalZOrder(lightZOrder);
                this.removeLight();
            })
        ));

        if (this.cell.algo.createAnimation) {
            this.animation.setAnimationAndIdleAfter(this.cell.algo.createAnimation, "idle");
        } else {
            this.animation.setAnimation(0, "idle", true);
        }
    },

    removeLight: function () {
        if (this.light) {
            this.light.stopAllActions();
            this.light.runAction(new cc.RemoveSelf());
            this.light = undefined;
        }
    },

    animateEffect: function () {
        this.removeLight();
        this.inShakeNow = true;

        if (this.cell.algo.bigZOrder) {
            this.setLocalZOrder(20);
        } else {
            this.setLocalZOrder(3);
        }

        this.effectSound();

        const goalCoefComponent = this.cell.findComponent(GoalCoefComponent);
        const coefView = goalCoefComponent && goalCoefComponent.view;

        if (this.cell.actionDirection) {
            if (coefView) {
                coefView.setVisible(false);
            }
            this.setLocalZOrder(22);
            const overshootCoef = cleverapps.styles.HeroCellView.animation.overshoot ? 0.25 : 0;
            const x = this.cell.x + (this.cell.actionLength + overshootCoef) * this.cell.actionDirection.x;
            const y = this.cell.y + (this.cell.actionLength + overshootCoef) * this.cell.actionDirection.y;
            const targetPosition = BaseCellView.alignInTheGrid(x, y);

            this.runAction(new cc.Sequence(
                new cc.DelayTime(this.cell.algo.action_delay * 0.8 / 1000),
                new cc.MoveTo(this.cell.algo.direct_timeout / 1000, targetPosition),
                new cc.CallFunc(() => {
                    if (coefView) {
                        coefView.setVisible(true);
                    }
                })
            ));

            const animationName = cleverapps.styles.HeroCellView.animation.direction;

            if (this.cell.actionDirection.x > 0) {
                this.animation.setAnimation(0, animationName.right, false);
            } else if (this.cell.actionDirection.x < 0) {
                this.animation.setAnimation(0, animationName.left, false);
            } else if (this.cell.actionDirection.y > 0) {
                this.animation.setAnimation(0, animationName.down, false);
            } else {
                this.animation.setAnimation(0, animationName.up, false);
            }
        } else {
            this.animation.setAnimation(0, "out", false);
        }

        this.animation.setCompleteListener(() => {
            this.animation.setAnimation(0, "idle", true);
            this.inShakeNow = false;
        });
    },

    effectSound: function () {
        const colorComponent = this.cell.findComponent(ColorComponent);
        if (colorComponent.color) {
            cleverapps.effects.fire(`match3.hero_sound.${colorComponent.color}`);
        }
    },

    smile: function () {
    },

    stopSmile: function () {
    },

    initialize: function (cell) {
        GoalColorCellView.prototype.initialize.call(this, cell);

        cell.algoEffectAnimation = this.animateEffect.bind(this);

        const comboComponent = cell.findComponent(ComboComponent);
        comboComponent.view.afterInitialize(cell);
    },

    unuse: function () {
        this.animation.visible = false;

        this.cell.algoEffectAnimation = function () {};

        const comboComponent = this.cell.findComponent(ComboComponent);
        comboComponent.view.beforeUnuse();

        this.stopSmile();

        GoalColorCellView.prototype.unuse.call(this);
    },

    reuse: function (cell) {
        this._super(cell);

        this.animation.setAnimation(0, "idle", true);
    },

    startExploding: function (goal, idInGroup, params) {
        if (this.cell.findComponent(GoalCoefComponent)) {
            GoalColorCellView.prototype.startExploding.call(this, goal, idInGroup, params);
        } else {
            ColorCellView.prototype.startExploding.call(this, goal, idInGroup, params);
        }
    },

    createFromCenterAnimation: function (...args) {
        this.animation.setAnimation(0, "idle", true);

        this._super(...args);
    }
});

// one color - one pool
// eslint-disable-next-line camelcase
const HeroCellView_A = HeroCellView.extend({});
// eslint-disable-next-line camelcase
const HeroCellView_B = HeroCellView.extend({});
// eslint-disable-next-line camelcase
const HeroCellView_C = HeroCellView.extend({});
// eslint-disable-next-line camelcase
const HeroCellView_D = HeroCellView.extend({});
// eslint-disable-next-line camelcase
const HeroCellView_E = HeroCellView.extend({});
// eslint-disable-next-line camelcase
const HeroCellView_W = HeroCellView.extend({});

cleverapps.styles.HeroCellView = {
    animation: {
        overshoot: true,

        direction: {
            left: "out",
            right: "out2",
            up: "out",
            down: "out2"
        }
    }
};